<template>
  <div class="activity-add">
    <iModal
      :title="title"
      v-model="showModal"
      class-name="vertical-center-modal v-center"
      width="600px"
      :mask-closable="false"
      @on-cancel="close()" 
    >
      <div class="my-modal">
        <div class="my-modal-content">
          <Form :label-width="100" ref="formInline" :rules="ruleInline">
            <FormItem label="banner：">
              <div
                class="my-upload-list"
                v-for="(item, index) in uploadList"
                :key="'upload' + index"
                style="width: 80px;height: 80px;line-height:80px"
              >
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" />
                  <div class="my-upload-list-cover">
                    <Icon
                      type="ios-trash-outline"
                      @click.native.stop.prevent="handleRemoveByArr(item)"
                    ></Icon>
                  </div>
                </template>
                <template v-else>
                  <Spin v-if="item.showProgress" style="width: 80px;height: 80px;">
                    <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                  </Spin>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :headers="formHeaders"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                type="drag"
                :action="uploadUrl"
                multiple
                style="display: inline-block;width:80px;"
                v-show="uploadList && uploadList.length < 1"
              >
                <div style="width: 80px;height:80px;padding-top: 7px;">
                  <div style="font-size:20px">
                    +
                    <p style="font-size:14px">上传</p>
                  </div>
                </div>
                <!-- 蒙版 -->
                <div
                  style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
                  @click.stop="selectType"
                ></div>
              </Upload>
              <p class="upload-p" style="font-size:12px">(图片要求：2M以下的jpg或png,建议尺寸750*500px)</p>
            </FormItem>
            <!-- <FormItem label="添加链接：" prop="Link">
              <Input v-model="formValidate.Link" placeholder="请输入外链地址" />
            </FormItem>-->
            <FormItem label="排序：" prop="ShowIndex">
              <InputNumber
                :max="9999"
                :min="1"
                v-model="formValidate.ShowIndex"
                placeholder="请输入排序"
              ></InputNumber>
            </FormItem>
            <FormItem label="显示状态：" prop="IsShow">
              <Checkbox v-model="formValidate.IsShow">
                <span style="display: inline-block; padding-right: 5px;"></span>
                {{ formValidate.IsShow ? '显示' : '屏蔽'}}
              </Checkbox>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit()">保存</Button>
        <Button @click="close()">取消</Button>
      </div>
    </iModal>

    <!-- 选择文件上传方式 -->
    <uploadChoose
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      fileType="img"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import uploadChoose from "@components/uploadChoose/uploadChoose";

export default {
  name: "add-photo",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    typeId: {
      type: Number,
      default: 0 // 0：顶部banner，1：企业风采（1张），2：图集（多张）
    },
    title: {
      type: String,
      default: "新增"
    }
  },
  data() {
    const that = this;
    const urlReg = (rule, value, callback) => {
      if (value) {
        if (/(https):\/\/([\w.]+\/?)\S*/.test(that.formValidate.Link)) {
          callback();
        } else {
          callback("请输入正确的外链地址");
        }
      } else {
        callback();
      }
    };
    return {
      showModal: false,
      loading: false,
      uploadList: [],
      defaultList: [],
      formValidate: {
        Link: "",
        ShowIndex: 1,
        IsShow: true
      },
      ruleInline: {
        // ShowIndex: [
        //   { required: true, message: "显示顺序为必填选项", trigger: "blur" }
        // ],
        Link: [{ validator: urlReg, trigger: "blur" }]
      },

      uploadChooseShowed: false // 控制文件上传方式的显示和隐藏
    };
  },
  components: {
    uploadChoose
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders"
    })
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  methods: {
    ...mapActions({
      addBanner: "bannerModule/addBanner"
    }),
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`每次Upload ${limitNum} image only`);
      }
      return check;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async handleSubmit() {
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传banner图`);
        return;
      }
      let valid = await this.validForm("formInline");
      if (!valid) return;
      let imgList = this.transfromImgList(this.uploadList);
      this.loading = true;
      setTimeout(c => {
        this.loading = false;
      }, 5000);
      let formData = {
        CompId: this.company.id,
        AgentId: this.company.agentId,
        Path: imgList[0],
        Link: this.formValidate.Link,
        TypeId: this.typeId,
        IsShow: this.formValidate.IsShow,
        ShowIndex: this.formValidate.ShowIndex
      };
      const bool = await this.addBanner(formData).catch(e => {
        this.$Message.error("添加失败，请重新尝试");
        this.loading = false;
        this.$emit("finish");
        this.close();
      });
      if (bool.successed) {
        this.$Message.success("添加成功");
        this.$emit("finish");
        this.close();
      } else {
        this.$Message.error("添加失败，请重新尝试");
      }
    },
    close() {
      this.loading = false;
      this.showModal = false;
      this.loading = false;
      this.uploadList = [];
      this.defaultList = [];
      if (this.$refs["upload"]) this.$refs["upload"].clearFiles();
      this.$emit("close");
    },

    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
        }
      }
    }
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
  }
};
</script>

<style lang="scss" scoped> 
</style>
<style lang="scss">
.v-center {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
</style>